import React, { SFC, JSX } from "react";
import withTheme, { PropsType as WithThemeProps } from "../../hoc/withTheme";
import withContentWrap, { PropsType as WithContentWrapProps } from "../../hoc/withContentWrap";
import withVerticalSpacing, { PropsType as WithVerticalSpacingProps } from "../../hoc/withVerticalSpacing";
import "./style.scss";

type PropsType = HTMLProps<HTMLDivElement> &
    WithVerticalSpacingProps &
    WithContentWrapProps &
    WithThemeProps & {
        content: string;
    };

const RichText: SFC<PropsType> = (props: PropsType): JSX.Element => {
    const theme = props.theme.text ? props.theme.text : "inherit";

    return (
        <div
            id={props.id}
            className="RichText"
            style={{ color: theme }}
            dangerouslySetInnerHTML={{ __html: props.content }}
        />
    );
};

export default withTheme(withVerticalSpacing(withContentWrap(RichText)));
